import dayjs from "dayjs";
import { Button, Col, Form, InputGroup } from "react-bootstrap";
import { defineValueInInput } from "../../../components/funcForInput";
import { DocumentoStatus } from "../pendentes/PainelDocumentosPendentes";

export default function FormUploadDocumento({ documentoDados, handleCriarDocumento }: iProps) {
    if (Object.values(documentoDados).length === 0) {
        return (
            <div id="documento_upload_dados">
                <div className="div-row" style={{ alignItems: "start" }}>
                    <Col className="col-4">
                        <Form.Label>Selecione o documento (pdf):</Form.Label>
                        <InputGroup>
                            <Form.Control type="file" name="documento" id="documento" aria-label="Selecione o Documento" accept=".pdf"></Form.Control>
                            <Button
                                variant="outline-secondary"
                                id="button-addon1"
                                onClick={() => {
                                    defineValueInInput("documento", null);
                                }}
                            >
                                Excluir
                            </Button>
                            <Form.Control name="documento_aux" type="text" id="documento_aux" placeholder="" style={{ display: "none" }} />
                            <Form.Control.Feedback type="invalid">Selecione o arquivo!</Form.Control.Feedback>
                        </InputGroup>
                    </Col>
                </div>
                <br></br>
                <div className="div-row">
                    <Col className="col-6">
                        <Button
                            variant="success"
                            style={{ marginRight: "10px" }}
                            onClick={() => {
                                handleCriarDocumento();
                            }}
                        >
                            Salvar Arquivo
                        </Button>
                    </Col>
                </div>
            </div>
        );
    }

    return (
        <div id="documento_upload_dados">
            <div className="div-row" style={{ alignItems: "start" }}>
                <Col className="col-4">
                    <Form.Label>Selecione o documento (pdf):</Form.Label>
                    <InputGroup>
                        <Form.Control type="file" name="documento" id="documento" aria-label="Selecione o Documento" accept=".pdf" disabled={true}></Form.Control>
                        <Button
                            variant="outline-secondary"
                            id="button-addon1"
                            onClick={() => {
                                defineValueInInput("documento", null);
                            }}
                            disabled={true}
                        >
                            Excluir
                        </Button>
                    </InputGroup>
                </Col>
                <Col className="col-6" style={{ margin: "0px 30px" }}>
                        <p style={{ marginBottom: "5px" }}>Código: {documentoDados.codigo}</p>
                        <p style={{ marginBottom: "5px" }}>Criado em: {dayjs(documentoDados.data_criacao).format("DD/MM/YYYY HH:mm:ss")}</p>
                        <p style={{ marginBottom: "5px" }}>Local: {documentoDados.id_pasta === null ? "Pasta Inicial" : documentoDados.id_pasta.descricao}</p>
                        <DocumentoStatus id_status={documentoDados.id_status.id_status} status={documentoDados.id_status.descricao} lixeira={documentoDados.lixeira} />
                    </Col>
            </div>
        </div>
    );
}
interface iProps {
    documentoDados: any;
    handleCriarDocumento: any;
}
